import { RouteConfig } from "vue-router";
import { routes as cadastroSaudeRoutes } from "@/views/private/cadastros/saude/router";
import { routes as cadastroAdministrativoRoutes } from "@/views/private/cadastros/administrativo/router";
import { usuarioStorage } from "@/store/usuario/UsuarioStorage";
import { RouteGuard } from "@/router/routeGuard";

const routes: Array<RouteConfig> = [
  ...cadastroAdministrativoRoutes,
  ...cadastroSaudeRoutes,
      {
        path: "/cadastros/assistencia/prestadores",
        name: "ListaPrestadores",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/ListaPrestadores.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/associados",
        name: "ListaAssociados",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/ListaAssociados.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },      
      {
        path: "/cadastros/assistencia/prestadores/cadastro/:idPrestador?",
        name: "CadastroPrestador",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/CadastroPrestador.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/clientes/cadastro/frota/:idCliente?",
        name: "CadastroClienteFrota",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/cliente/CadastroClienteFrota.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/clientes/detalhe/:idCliente?",
        name: "DetalhesCliente",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/cliente/DetalhesCliente.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/associados/frota",
        name: "ListaAssociadosFrota",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/ListaAssociadosFrota.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/prestadores/lista-precificacao",
        name: "ListaPrecificacoes",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/precificacao/ListaPrecificacoes.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/prestadores/cadastro-preco",
        name: "CadastroPrecificacao",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/precificacao/CadastroPrecificacao.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/faixa-percental-servicos",
        name: "FaixaPercentualServicos",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/FaixaPercentualServicos.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/agentes",
        name: "ListaAgentes",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/agente/ListaAgentes.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/agentes/cadastro/agente/:idCliente?",
        name: "CadastroAgente",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/agente/CadastroAgente.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/guincho",
        name: "CadastroGuincho",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/questionario/Guincho.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/carga-bateria",
        name: "CadastroCargaBateria",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/questionario/CargaBateria.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/chaveiro",
        name: "CadastroChaveiro",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/questionario/Chaveiro.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
      {
        path: "/cadastros/assistencia/troca-pneu",
        name: "CadastroTrocaPneu",
        component: () => import(/* webpackChunkName: "cadastros" */ "@/views/private/cadastros/assistencia/questionario/TrocaPneu.vue"),
        beforeEnter: RouteGuard.acessoAssistencia
      },
]
export default routes;
